module.exports = __webpack_public_path__ + "img/level_2.a86542b9.svg";